import { PermissionsScope } from '../../policies/policy.model'

export const SUPPLIER_ORDER_SCOPE: PermissionsScope = 'supplierOrders'
export const SUPPLIER_ORDER_PATH_KEY = 'supplier-order'
export const SUPPLIER_ORDER_FRAGMENT = 'supplier-order'
